export default {
   namespaced: true,
   state() {
       return {
         muayThai: {
            title: "Muay Thai Champion",
            rating: 4.8,
            userRating: "999",
            RTP: 99.8,
            players: 100,
            gameDescription: "Muay Thai is a unique fighting skill characterized for its strength and agility. During a fight, Muay Thai uses a combination of fists, elbows, knees, and shins during strikes that creates 8 points of contact, hence the term Art of Eight Limbs is used to describe Muay Thai. In addition to being a fighting technique, Muay Thai has evolved into combining with various other skills such as entertainment, martial arts, art and sports. This fighting technique has since become part of the unique treasure of the Thai nation, and has grown into becoming a worldwide fighting sport.",
            gameThemes: [
               "Adventure",
               "War",
               "3D",
               "Acade",
               "Action"
            ]
         },
         muayThaiReviews: {
            review1: {src: require("../../assets/casino/MuayThai/gameReviews/MuayThaiChampion_MainGame.jpg")},
            review2: {src: require("../../assets/casino/MuayThai/gameReviews/MuayThaiChampion_FreeSpinsFeature_Loading.jpg")},
            review3: {src: require("../../assets/casino/MuayThai/gameReviews/MuayThaiChampion_SplashScreen.jpg")},
            review4: {src: require("../../assets/casino/MuayThai/gameReviews/MuayThaiChampion_FreeSpinsFeature_Loading.jpg")},
            review5: {src: require("../../assets/casino/MuayThai/gameReviews/MuayThaiChampion_FreeSpinsFeature_TotalWinSettlement.jpg")},
         },
			pocketGameList: {
				baliVacation: {
               title:"Bali Vacation",
               src: require("../../assets/casino/MuayThai/similarGames/baliVacation.jpeg"),
               rating: 4,
               userRating: 100
            },
				cleopatra: {
               title:"Secrets of Cleopatra",
               src: require("../../assets/casino/MuayThai/similarGames/cleopatra.jpeg"),
               rating: 5,
               userRating: 898
            },
				fortuneOx: {
               title:"Fortune Ox",
               src: require("../../assets/casino/MuayThai/similarGames/fortuneOx.jpeg"),
               rating: 3,
               userRating: 364
            },
				galactic: {
               title:"Galactic",
               src: require("../../assets/casino/MuayThai/similarGames/galactic.png"),
               rating: 4,
               userRating: 132
            },
				guardiansIceFire: {
               title:"Guardians of Ice & Fire",
               src: require("../../assets/casino/MuayThai/similarGames/guardiansIceFire.jpeg"),
               rating: 3,
               userRating: 876
            },
				jewelOfProsperity: {
               title:"Jewels of Prosperity",
               src: require("../../assets/casino/MuayThai/similarGames/jewelOfProsperity.jpeg"),
               rating: 1,
               userRating: 43
            },
				queenOfBounty: {
               title:"Queen Of Bounty",
               src: require("../../assets/casino/MuayThai/similarGames/queenOfBounty.png"),
               rating: 2,
               userRating: 122
            },
				vampireCharm: {
               title:"Vampire Charm",
               src: require("../../assets/casino/MuayThai/similarGames/vampireCharm.jpeg"),
               rating: 5,
               userRating: 999
            },
			},
       }
   },
   getters: {
      muayThai(state){
         return state.muayThai
      },
      pocketGameList(state){
         return state.pocketGameList
      },
      muayThaiReviews(state){
         return state.muayThaiReviews
      }
   }
}